<template>
  <div :class="showCustomBackground ? '.custom-calendar-bg' : ''">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "CustomCalendarBackground",
  props: {
    showCustomBackground: {
      type: Boolean, 
      default: true,
    }
  },
}
</script>
<style>
.custom-calendar-bg {
  background-size: 100% 100%;
  background: var(--calendar-background-color);
}
</style>